import React, { Component } from "react";
import AuthTopNav from "../containers/TopNav/AuthTopNav";
import Footer from "../containers/Footer";
import MobileNavbar from "../containers/MobileNavbar";
import "../styles/_calendar.scss";
import CircleAdministration from "../containers/CircleAdministration";
class CircleAdmin extends Component {
  render() {
    return (
      <div className="app-wrapper has-mobile-navbar">
        <AuthTopNav />
        <CircleAdministration circleId={this.props.match.params.circleId} />
        <MobileNavbar />
        <Footer />
      </div>
    );
  }
}

export default CircleAdmin;
